/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Drop_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "They won't be seated in later rounds. Their scores so far are kept. You can check them back in." |
*
* @param {Players_Drop_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_drop_confirm_body = /** @type {((inputs?: Players_Drop_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Drop_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il ne sera plus placé aux rondes suivantes. Ses scores sont conservés. Vous pouvez le pointer à nouveau.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se le sentará en las rondas siguientes. Sus resultados se conservan. Puede volver a hacerle el check-in.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não será mais colocado nas próximas rodadas. Os resultados dele ficam. Você pode fazer o check-in dele de novo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non sarà più messo a sedere nei round successivi. I suoi punteggi restano. Puoi rifargli il check-in.")
	return /** @type {LocalizedString} */ ("They won't be seated in later rounds. Their scores so far are kept. You can check them back in.")
});